
import { defineComponent, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useIndustryModule } from '@/modules/industries'
import QForm from 'quasar/src/components/form/QForm.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
import { Industry } from '@/modules/industries/types'
import IndustriesFormFieldIndustry from '@/components/industries/form-fields/industry.vue'
import { requiredRule, useFormModule } from '@/modules/_shared/forms'
import { IndustriesRouteNames } from '@/router/routes-names'
import DeleteIndustryDialog from '@/components/industries/dialogs/delete-industry.vue'
import router from '@/router'

export default defineComponent({
    name: 'industries-edit-industry-form',
    components: { IndustriesFormFieldIndustry },
    async setup (props, { emit }) {
        const $q = useQuasar()
        const { submitForm } = useFormModule()
        const { getSingleIndustry, updateIndustry } = useIndustryModule()
        const route = useRoute()

        const industry = await getSingleIndustry(route.params.id as string)

        const industryModel = reactive<Industry>({
            id: industry.id,
            name: industry.name
        })

        const form = ref<QForm>()
        const emitEvent = () => emit('formSent')

        const sendForm = async () => updateIndustry(industryModel.id.toString(), industryModel)

        const onSubmit = () => submitForm(
            form.value,
            sendForm,
            () => {
                router.push({ name: IndustriesRouteNames.LIST, query: { page: route.query.page } })
                $q.notify({
                    color: 'positive',
                    message: 'Industry updated!'
                })
            }
        ).then(emitEvent)

        async function onDeleteIndustry (industry: Industry) {
            $q.dialog({
                component: DeleteIndustryDialog,
                componentProps: {
                    industryId: industry.id,
                    industryName: industry.name,
                    onDeletedCallback: async () => {
                        await router.push({ name: IndustriesRouteNames.LIST, query: { page: route.query.page } })
                    }
                }
            })
        }

        return {
            requiredRule,
            onSubmit,
            industryModel,
            form,
            onDeleteIndustry,
            IndustriesRouteNames,
            route
        }
    }
})
